<template>
  <div class="profile">
    <CustomerSection />
    <ContactsSection />
    <PasswordSection />
    <div class="profile__footer">
      <button
        type="button"
        :aria-label="_T('@Logout')"
        class="profile__logout"
        @click.prevent="onLogout"
      >
        <img src="~~/assets/icons/account-exit-orange.svg" alt="logout" />
        <span>{{ _T("@Logout") }}</span>
      </button>
    </div>
  </div>
</template>
<script setup>
import { useUserStore } from "~/store/userStore";
import CustomerSection from "~/modules/account/ui/pages/Profile/CustomerSection.vue";
import ContactsSection from "~/modules/account/ui/pages/Profile/ContactsSection.vue";
import PasswordSection from "~/modules/account/ui/pages/Profile/PasswordSection.vue";

const userStore = useUserStore();

const onLogout = () => {
  userStore.logout().then(() => {
    return navigateTo({ name: getLocalizedRouteName("home") });
  });
};
</script>

<style lang="scss">
.section {
  &__info {
    @include font(20, 26);

    @include bigMobile {
      @include font(18, 24);
    }
  }

  &__info-label {
    @include font(14, 16);
  }

  &__form {
    @include flex-container(column, flex-start, flex-start);
    gap: 16px;
  }

  &__fields {
    width: 100%;

    @include flex-container(row, flex-start, flex-start);
    gap: 24px;

    @include bigMobile {
      flex-wrap: wrap;
    }
  }
}
</style>

<style lang="scss" scoped>
.profile {
  width: 100%;

  border-radius: 8px;
  border: 1px solid var(--color-sky-lighter);

  background-color: white;

  @include bigMobile {
    border: none;
  }

  &__footer {
    width: 100%;

    @include flex-container(column, center, flex-start);
    gap: 24px;

    padding: 24px;
  }

  &__logout {
    @include flex-container(row, flex-start, center);
    gap: 16px;

    color: var(--color-primary-base);

    @include bigMobile {
      margin-inline: auto;
    }
  }
}
</style>
